import { SORT_DIRECTION } from "../../../constants";

export const consumerResponsesConstants = {
  CUSTOMER_RESPONSE_DATA: "CUSTOMER_RESPONSE_DATA",
  GET_ORDER_DETAIL: "GET_ORDER_DETAIL",
  RESTAURANT_EXTERNAL_ID: "RestaurantExternalId",
  DEFAULT_SORT_ID: "externalOrderId",
  DEFAULT_SORT_DESC: SORT_DIRECTION.DESCENDING,
};

export const CONSUMER_RESPONSES_LABELS = {
  ORDERS_PLACED: "ORDERS PLACED:",
  SURVEYS_COMPLETED: "SURVEYS COMPLETED:",
  PARTICIPATION_RATE: "PARTICIPATION RATE:",
  AVERAGE_TRANSACTION_RATING: "AVERAGE TRANSACTION RATING:",
  AVERAGE_SENTIMENT_RATING: "AVERAGE SENTIMENT RATING:",
  COMPLETED_SURVEYS: "Completed Surveys:",
  SEARCH_PLACEHOLDER: "Search",
  QUESTION_PREFIX: "Question ",
  ORDER_NUMBER: "ORDER NUMBER:",
  ORDER_DATE: "ORDER DATE:",
  SURVEY_COMPLETION_DATE: "SURVEY COMPLETION DATE:",
  SENTIMENT_RATING: "SENTIMENT RATING:",
  TRANSACTION_RATING: "TRANSACTION RATING:",
  INTERNAL_NOTES: "INTERNAL NOTES",
};

export const CONSUMER_RESPONSE_METRIC_HEADERS = [
  CONSUMER_RESPONSES_LABELS.ORDERS_PLACED,
  CONSUMER_RESPONSES_LABELS.SURVEYS_COMPLETED,
  CONSUMER_RESPONSES_LABELS.PARTICIPATION_RATE,
  CONSUMER_RESPONSES_LABELS.AVERAGE_TRANSACTION_RATING,
  CONSUMER_RESPONSES_LABELS.AVERAGE_SENTIMENT_RATING,
];
